export default "__VITE_ASSET__CK2oJ0Ds__"